var itemListColumnOne = false;

//SPメニューボタン
$(function(){

	var col = localStorage.getItem("col");
	if(col == "three"){
		itemListColumnOne = false;
	}else{
		itemListColumnOne = true;
	}


	$('.btn_open_search_modal').click(function(){

		console.log("open");

		$('.search-modal').fadeIn(300);

		closeHeaderSearchMenu();

	});

	$('.modal__close-button').click(function(){

		$('.search-modal').fadeOut(300);

	});

	$('#ProductCount').hide();


	//item_list
	$('.list_header .column_01').click(function(){
		itemListColumnOne = true;
	});
	$('.list_header .column_02').click(function(){
		itemListColumnOne = false;
	});

	if(document.location.pathname.match(/collections/) || document.location.pathname.match(/search/)){
		// 商品一覧ページ

		$('input#filter-cat-all').change(function(){
			if($('input#filter-cat-all').prop('checked')){
				$('input[name="filter.p.m.custom.category"]').prop('checked', false);
			}
		});
		$('input:checkbox[name="filter.p.m.custom.category"]').change(function(e){
			if($(e.currentTarget).prop('checked')){
				$('input#filter-cat-all').prop('checked', false);
			}
		});

		// 英語の時は、作家を選択するメニューを非表示
		if(document.location.pathname.match(/\/en\//)){
			$(".sort_box.author").hide();
		}

		const paramsStr = window.location.search;
		const params = paramsStr.split("&");
		params.forEach((p) => {
			const kv = p.split("=");
			if(kv[1]){
				$('input:checkbox[name="'+ decodeURI(kv[0].replace("?", "")) + '"]').each((i, c) => {
					if($(c).val() == decodeURI(kv[1])){

            if(kv[0] == "filter.v.price.gte" || kv[0] == "filter.v.price.lte"){
              const num = $(c).attr('id').split('-')[2];
              $(`#Filter-price-${num}`).prop('checked', true);
			  $(`#Filter-price-${num}-mobile`).prop('checked', true);
            }else{
              $(c).prop('checked', true);
            }

						if(kv[0] == "filter.p.m.custom.color"){
							$(c).next().addClass('active');
              $('#FacetColorFormMoBile label[for="'+$(c).attr('id')+'"]').addClass('active');
						}
					}
				});
			}
		});

	}


  // 作家検索用 作家取得
  const authors = [];
  const kodawaris = [];

  // ページから作家とこだわりを抽出する関数
  function extractAuthorsAndKodawaris(responseText) {
    var doc = new DOMParser().parseFromString(responseText, 'text/html');
    var authorsElement = doc.getElementById('authors');
    var kodawarisElement = doc.getElementById('kodawaris');
    
    if(authorsElement) {
      var authorElements = authorsElement.getElementsByClassName('author');
      Array.from(authorElements).forEach((e) => {
        var authorText = e.textContent.replace(/\t/g, '').replace(/\n/g, '').trim();
        if(authorText && authorText.length > 0) {
          authors.push(authorText);
        }
      });
    }
    
    if(kodawarisElement) {
      var kodawariElements = kodawarisElement.getElementsByClassName('kodawari');
      Array.from(kodawariElements).forEach((e) => {
        var kodawariText = e.textContent.replace(/\t/g, '').replace(/\n/g, '').trim();
        if(kodawariText && kodawariText.length > 0) {
          kodawaris.push(kodawariText);
        }
      });
    }
  }

  // ページを順次取得する関数
  function fetchPage(pageNum) {
    if(pageNum === 1) {
      return fetch("/pages/authors").then(response => response.text());
    } else {
      return fetch("/pages/authors?page=" + pageNum).then(response => {
        if(response.status === 404) {
          return null; // ページが存在しない場合はnullを返す
        }
        return response.text();
      });
    }
  }

  // 全ページを取得（最大11ページまで）
  var fetchPromises = [];
  for(var page = 1; page <= 11; page++) {
    fetchPromises.push(
      fetchPage(page)
        .then((responseText) => {
          if(responseText) {
            extractAuthorsAndKodawaris(responseText);
          }
        })
        .catch((error) => {
          // エラーが発生しても続行
          console.warn('Failed to fetch page ' + page + ':', error);
        })
    );
  }

  // すべてのページの取得が完了したら処理を実行
  Promise.all(fetchPromises).then(() => {

    var _authors = new Set(authors);
    var _kodawaris = new Set(kodawaris);
    var __authors = Array.from(_authors);
    var __kodawaris = Array.from(_kodawaris);
    __authors.sort();
    __kodawaris.sort();

    var htmlA = '<div class="author_select">';
    htmlA += "<p>\"<span>ア</span>\"から始まる作家</p>";
    htmlA += '<div class="author_area">';

    var htmlAf = '<div class="author_select">';
    htmlAf += "<p>\"<span>ア</span>\"から始まる作家</p>";
    htmlAf += '<div class="author_area">';

    var topStr = "";
    var pastTopStr = "";
    __authors.forEach((e, i) => {
            topStr = e.charAt(0);
            if(topStr != pastTopStr) {
              if(pastTopStr != ""){
                htmlA += "</ul>";
                htmlAf += "</ul>";
              }
              htmlA += '<ul class="'+topStr+'">';
              htmlA += '	<li>';
              //htmlA += '		<input type="checkbox" name="filter.p.m.custom.author_name" value="'+e+'" id="Filter-'+e+'-'+i+'">';
              htmlA += '		<a href="/collections/all?filter.p.m.custom.author_name='+e+'">';
              htmlAf += '<ul class="'+topStr+'">';
              htmlAf += '	<li>';
              htmlAf += '		<input type="checkbox" name="filter.p.m.custom.author_name" value="'+e+'" id="Filter-'+e+'-'+i+'-mobile">';
              htmlAf += '   <label for="Filter-'+e+'-'+i+'-mobile">';
              var authorNameArr = e.split('/');
              if(authorNameArr[1]){
                htmlA += authorNameArr[1] + '(' + authorNameArr[0] + ')';
                htmlAf += authorNameArr[1] + '(' + authorNameArr[0] + ')';
              }else{
                htmlA += authorNameArr[0];
                htmlAf += authorNameArr[0];
              }
              htmlAf += '   </label>';
              htmlA += '<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span>';
              htmlA += '	</li>';
              htmlAf += '	</li>';

            }else{
              htmlA += '	<li>';
              htmlA += '		<a href="/collections/all?filter.p.m.custom.author_name='+e+'">';
              htmlAf += '	<li>';
              htmlAf += '		<input type="checkbox" name="filter.p.m.custom.author_name" value="'+e+'" id="Filter-'+e+'-'+i+'-mobile">';
              htmlAf += '   <label for="Filter-'+e+'-'+i+'-mobile">';
              var authorNameArr = e.split('/');
              if(authorNameArr[1]){
                htmlA += authorNameArr[1] + '(' + authorNameArr[0] + ')';
                htmlAf += authorNameArr[1] + '(' + authorNameArr[0] + ')';
              }else{
                htmlA += authorNameArr[0];
                htmlAf += authorNameArr[0];
              }
              htmlAf += '   </label>';
              htmlA += '<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span>';
              htmlA += '	</li>';
              htmlAf += '	</li>';
            }
            pastTopStr = topStr;
          });
          htmlA += "</ul>";
          htmlA += "</div>";
          htmlA += "</div>";
          htmlAf += "</ul>";
          htmlAf += "</div>";
          htmlAf += "</div>";

    if(document.getElementsByClassName('authors').length){
      document.getElementsByClassName('authors')[0].innerHTML = htmlA;
    }

    if(document.getElementsByClassName('authors_filter').length){
      document.getElementById('authors_filter').innerHTML = htmlAf.replaceAll('-mobile', '');
      document.getElementById('authors_filter-mobile').innerHTML = htmlAf;
    }

    var htmlK = '<ul>';
    var htmlKl = '<ul>';
    __kodawaris.forEach((e, i) => {
            htmlK += '	<li>';
            htmlK += '		<input type="checkbox" name="filter.p.m.custom.kodawari" value="'+e+'" id="Filter-'+e+'-'+i+'-mobile">';
            htmlK += `    <label for="Filter-${e}-${i}-mobile">${e}</label>`;
            htmlK += '	</li>';

            htmlKl += '	<li>';
            htmlKl += '		<a href="/collections/all?filter.p.m.custom.kodawari='+e+'">'+e+'<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span></a>';
            htmlK += '	</li>';
          });
          htmlK += '</ul>';
          htmlKl += '</ul>';

    if(document.getElementsByClassName('kodawaris').length){
      document.getElementById('kodawaris').innerHTML = htmlK.replaceAll('-mobile', '');
      document.getElementById('kodawaris-mobile').innerHTML = htmlK;
    }
    
    if(document.getElementsByClassName('kodawaris_link').length){
      document.getElementsByClassName('kodawaris_link')[0].innerHTML = htmlKl;
    }
    

    setDefaultCloseList();

    const paramsStr = window.location.search;
    const params = paramsStr.split("&");
    params.forEach((p) => {
      const kv = p.split("=");
      if(kv[1]){
        $('input:checkbox[name="'+ decodeURI(kv[0].replace("?", "")) + '"]').each((i, c) => {
          if($(c).val() == decodeURI(kv[1]).replace(/%2F/gi, "/").replace('+', " ")){
            $(c).prop('checked', true);
          }
        });
      }
    });
  });



	if(document.location.pathname.match(/products/)){
		// 商品詳細ページで、お問合せフォーム用に、localstorageに商品情報を保存しておく
		const productName = $(".ttl_box h1")[0].innerText;
		const authorName = $(".ttl_box h2")[0].innerText;
		localStorage.setItem('productInfo', authorName + " / " + productName);
	}

	if(document.location.pathname.match(/pages\/payment/) || document.location.pathname.match(/pages\/contact-product/)){
		// 郵便振替用紙払い・分割払いページ
		const productInfo = localStorage.getItem('productInfo');
		if(productInfo) {
			$("#ContactForm-item")[0].value = productInfo;
		}
	}


	if(document.location.pathname.match(/products/)){
		// 商品詳細ページのサイドバーを、商品一覧ページのhidden部分から持ってくる
		const url = "/collections/all";
		fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
				var html2 = new DOMParser().parseFromString(html, 'text/html').getElementById('facetsForProductDetail').innerHTML
				document.getElementById('productDetailFacets').innerHTML = html2;

				// 英語の時は、作家を選択するメニューを非表示
				if(document.location.pathname.match(/\/en\//)){
					$(".sort_box.author").hide();
				}

				$("aside .cat_ttl").click(function(){
					if($(this).hasClass('active')){
								$(this).removeClass('active');
						} else {
						$(this).addClass('active');
					}
					$(this).parent(".sort_box").find("ul").slideToggle(300);
				});

				//開くボタンをクリックしたらモーダルを表示する
				$('.modal-open-3').on('click',function(){
						$('.modal-container-3').addClass('active');
						if(!$('.modal-container.active').length){
							bodyFixedOn();
						}else{
							modalFixedOn();
						}
						return false;
				});

				//閉じるボタンをクリックしたらモーダルを閉じる
				$('.modal-close-3').on('click',function(){
						$('.modal-container-3').removeClass('active');
						if(!$('.modal-container.active').length){
							bodyFixedOff();
						}else{
							modalFixedOff();
						}
				});

				/*a~z*/
				$(function(){
					$(".modal-content-3 .link li a, .modal-content-2 .link li a, .modal-content .link li a").click(function(){
						var string = $(this).attr("class");

						$(".author_select ul").css("display","none");

				    $(".modal-content ul"+"."+string).css("display", "flex");
				    $(".modal-content-2 ul"+"."+string).css("display", "flex");
						$(".modal-content-3 ul"+"."+string).css("display", "flex");

				    var dakuten = unescape(escape(string)+'%u3099').normalize();
				    var handakuten = unescape(escape(string)+'%u309a').normalize();

				    $(".modal-content ul"+"."+dakuten).css("display", "flex");
						$(".modal-content-2 ul"+"."+dakuten).css("display", "flex");
				    $(".modal-content-3 ul"+"."+dakuten).css("display", "flex");

				    $(".modal-content ul"+"."+handakuten).css("display", "flex");
				    $(".modal-content-2 ul"+"."+handakuten).css("display", "flex");
				    $(".modal-content-3 ul"+"."+handakuten).css("display", "flex");

						$(".author_select p span").html(string);

						$(".author_area").scrollTop(0);

						return false;
					})
				})

				// const authors = [];
				// const kodawaris = [];

				// fetch("/pages/authors")
		    //   .then(response => response.text())
		    //   .then((responseText) => {
				// 		var htmlAuthors = new DOMParser().parseFromString(responseText, 'text/html').getElementById('authors').getElementsByClassName('author')
				// 		_htmlAuthors = Array.from(htmlAuthors);
				// 		_htmlAuthors.forEach((e, i) => {
				// 			authors.push(e.textContent.replace(/\t/g, '').replace(/\n/g, ''));
				// 		});
				// 		var htmlKodawaris = new DOMParser().parseFromString(responseText, 'text/html').getElementById('kodawaris').getElementsByClassName('kodawari')
				// 		_htmlKodawaris = Array.from(htmlKodawaris);
				// 		_htmlKodawaris.forEach((e, i) => {
				// 			kodawaris.push(e.textContent.replace(/\t/g, '').replace(/\n/g, ''));
				// 		});

				// 		fetch("/pages/authors?page=2")
				// 			.then(response => response.text())
				// 			.then((responseText) => {
				// 				var htmlAuthors2 = new DOMParser().parseFromString(responseText, 'text/html').getElementById('authors').getElementsByClassName('author')
				// 				_htmlAuthors2 = Array.from(htmlAuthors2);
				// 				_htmlAuthors2.forEach((e, i) => {
				// 					authors.push(e.textContent.replace(/\t/g, '').replace(/\n/g, ''));
				// 				});
				// 				var htmlKodawaris2 = new DOMParser().parseFromString(responseText, 'text/html').getElementById('kodawaris').getElementsByClassName('kodawari')
				// 				_htmlKodawaris2 = Array.from(htmlKodawaris2);
				// 				_htmlKodawaris2.forEach((e, i) => {
				// 					kodawaris.push(e.textContent.replace(/\t/g, '').replace(/\n/g, ''));
				// 				});

				// 				var _authors = new Set(authors);
				// 				var _kodawaris = new Set(kodawaris);
				// 				var __authors = Array.from(_authors);
				// 				var __kodawaris = Array.from(_kodawaris);
				// 				__authors.sort();
				// 				__kodawaris.sort();

				// 				var htmlA = '<div class="author_select">';
				// 				htmlA += "<p>\"<span>ア</span>\"から始まる作家</p>";
				// 				htmlA += '<div class="author_area">';
				// 				var topStr = "";
				// 				var pastTopStr = "";
				// 				__authors.forEach((e, i) => {
				// 					topStr = e.charAt(0);
				// 					if(topStr != pastTopStr) {
				// 						if(pastTopStr != ""){
				// 							htmlA += "</ul>";
				// 						}
				// 						htmlA += '<ul class="'+topStr+'">';
				// 						htmlA += '	<li>';
				// 						htmlA += '		<a href="/collections/all?filter.p.m.custom.author_name='+e+'">';
				// 						var authorNameArr = e.split('/');
				// 						if(authorNameArr[1]){
				// 							htmlA += authorNameArr[1] + '(' + authorNameArr[0] + ')';
				// 						}else{
				// 							htmlA += authorNameArr[0];
				// 						}
				// 						htmlA += '<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span>';
				// 						htmlA += '	</li>';

				// 					}else{
				// 						htmlA += '	<li>';
				// 						htmlA += '		<a href="/collections/all?filter.p.m.custom.author_name='+e+'">';
				// 						var authorNameArr = e.split('/');
				// 						if(authorNameArr[1]){
				// 							htmlA += authorNameArr[1] + '(' + authorNameArr[0] + ')';
				// 						}else{
				// 							htmlA += authorNameArr[0];
				// 						}
				// 						htmlA += '<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span>';
				// 						htmlA += '	</li>';
				// 					}
				// 					pastTopStr = topStr;
				// 				});
				// 				htmlA += "</ul>";
				// 				htmlA += "</div>";
				// 				htmlA += "</div>";

				// 				document.getElementById('authors').innerHTML = htmlA;
				// 				// document.getElementById('authors').innerHTML = htmlA;

				// 				var htmlK = '<ul>';
        //         var htmlKl = '<ul>';
				// 				__kodawaris.forEach((e, i) => {
        //           htmlK += '	<li>';
        //           htmlK += '		<input type="checkbox" name="filter.p.m.custom.kodawari" value="'+e+'" id="Filter-'+e+'-'+i+'">';
        //           htmlK += `    <label for="Filter-${e}-${i}">${e}</label>`;
        //           htmlK += '	</li>';

        //           htmlKl += '	<li>';
				// 					htmlKl += '		<a href="/collections/all?filter.p.m.custom.kodawari='+e+'">'+e+'<span><img src="https://cdn.shopify.com/s/files/1/0629/9107/3479/files/icon_arrow_right.png?v=1674902993" width="12"></span></a>';
				// 					htmlKl += '	</li>';
				// 				});
				// 				htmlK += '</ul>';

				// 				document.getElementsByClassName('kodawaris')[0].innerHTML = htmlK;
				// 				document.getElementsByClassName('kodawaris')[1].innerHTML = htmlK;

        //         document.getElementsByClassName('kodawaris_link')[0].innerHTML = htmlKl;

				// 				setDefaultCloseList();

				// 				params.forEach((p) => {
				// 					const kv = p.split("=");
				// 					if(kv[1]){
				// 						$('input:checkbox[name="'+ decodeURI(kv[0].replace("?", "")) + '"]').each((i, c) => {
        //               if($(c).val() == decodeURI(kv[1]).replace(/%2F/gi, "/")){
				// 								$(c).prop('checked', true);
				// 							}
				// 						});
				// 					}
				// 				});

				// 			});

				// });

    });
	}

});
